module.exports = __webpack_public_path__ + "static/datasecuritybanner-78d3414cb64ebc174a6a1747a9008fa3.jpg";